<template>
    <g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.9107 13.9224C6.58527 13.597 6.58527 13.0694 6.9107 12.7439L11.3214 8.33317L1.66662 8.33317C1.20639 8.33317 0.833292 7.96007 0.833292 7.49984C0.833292 7.0396 1.20639 6.6665 1.66662 6.6665L11.3214 6.6665L6.9107 2.25576C6.58527 1.93032 6.58527 1.40268 6.9107 1.07725C7.23614 0.75181 7.76378 0.75181 8.08921 1.07725L13.9225 6.91058C14.248 7.23602 14.248 7.76366 13.9225 8.08909L8.08921 13.9224C7.76378 14.2479 7.23614 14.2479 6.9107 13.9224Z"
            :fill="iconFill"
        />
    </g>
</template>
<script>
export default {
    name: "ArrowRight",
    props: {
        iconFill: {
            type: String,
            default: "#206CFF",
        },
    },
};
</script>
